export default __webpack_public_path__ + "static/media/profile-pic.487211d7.jpeg";